import { useState, useEffect } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { valueThuThuat } from "./DetailThuThuatData";
import { getUserProfile } from "../../utilities/axios.utilities";

const HomeCasino = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const navigate = useNavigate();
  const [coin, setCoin] = useState(0);

  useEffect(() => {
    const loadUserProfile = async () => {
      try {
        const userData = await getUserProfile();
        setCoin(userData.coins);
      } catch (error) {
        console.error("Error loading user profile:", error);
      }
    };
    loadUserProfile();
  }, []);

  const handleClick = (link: string, description: string, requiredCoin: number) => {
    if (coin < requiredCoin) {
      Swal.fire({
        title: 'Không đủ xu',
        text: `Số xu hiện tại của bạn không đủ để xem thủ thuật này. Bạn cần ${requiredCoin} xu để xem thủ thuật này`,
        icon: 'error',
        confirmButtonText: 'Đóng',
        confirmButtonColor: '#d33',
        background: '#000000bd',
        color: '#fff',
        customClass: {
          popup: 'swal2-popup',
          title: 'swal2-title',
          htmlContainer: 'swal2-content',
          confirmButton: 'swal2-confirm',
        }
      });
      return;
    }

    Swal.fire({
      title: 'Xác nhận',
      text: description,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Có',
      confirmButtonColor: '#54954b',
      cancelButtonText: 'Không',
      cancelButtonColor: '#d33',
      background: '#000000bd',
      color: '#fff',
      customClass: {
        popup: 'swal2-popup',
        title: 'swal2-title',
        htmlContainer: 'swal2-content',
        confirmButton: 'swal2-confirm',
        cancelButton: 'swal2-cancel',
      }
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/trickBacarat${link}`);
      }
    });
  };

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="container-fluid lobby-bg position-relative  mx-auto  mb-5 max-w-screen-xl">
        <div className="container mx-auto">
          <div className="flex flex-wrap my-7">
            <div className="w-1/2 md:w-2/3">
              <img
                src="/assets/casino/all-room.png"
                alt="Slot"
                className="!w-[50%] h-auto"
              />
            </div>
            <div className="w-1/2 md:w-1/3 flex justify-center items-center">
              <a href="/" className="text-white no-underline">
                <div className="text-white px-4 py-2 rounded-lg shadow box-goto-lobby w-[10rem]">
                  Quay lại
                </div>
              </a>
            </div>
          </div>
          <div
            id="lobbySlotMain"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-3 all-programs py-8 mb-10 "
          >
            {valueThuThuat.map((e) => {
              return (
                <div
                  data-aos="flip-left"
                  data-aos-delay="100"
                  className="mb-3 aos-init aos-animate cursor-pointer transition-transform hover:scale-105 "
                  onClick={() => handleClick(e.link, e.description, e.coin)}
                >
                  <div className="box-game">
                    <img
                      src={e.url}
                      alt="Thủ thuật"
                      className="img-game w-full"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomeCasino;
